/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadBatchSummary } from './UploadBatchSummary';
import {
    UploadBatchSummaryFromJSON,
    UploadBatchSummaryFromJSONTyped,
    UploadBatchSummaryToJSON,
    UploadBatchSummaryToJSONTyped,
} from './UploadBatchSummary';

/**
 * 
 * @export
 * @interface UploadBatchListResponse
 */
export interface UploadBatchListResponse {
    /**
     * 
     */
    batches: Array<UploadBatchSummary>;
}

/**
 * Check if a given object implements the UploadBatchListResponse interface.
 */
export function instanceOfUploadBatchListResponse(value: object): value is UploadBatchListResponse {
    if (!('batches' in value) || value['batches'] === undefined) return false;
    return true;
}

export function UploadBatchListResponseFromJSON(json: any): UploadBatchListResponse {
    return UploadBatchListResponseFromJSONTyped(json, false);
}

export function UploadBatchListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBatchListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'batches': ((json['batches'] as Array<any>).map(UploadBatchSummaryFromJSON)),
    };
}

export function UploadBatchListResponseToJSON(json: any): UploadBatchListResponse {
    return UploadBatchListResponseToJSONTyped(json, false);
}

export function UploadBatchListResponseToJSONTyped(value?: UploadBatchListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'batches': ((value['batches'] as Array<any>).map(UploadBatchSummaryToJSON)),
    };
}

